import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ShipmentOrderSpec } from '@core/models/job-file/shipment-order-spec.model';
import { ConfirmationDialogComponent, ConfirmationDialogData, ConfirmationDialogResult } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { JobFile } from '@core/models/job-file';
import { LoadManagementState } from 'app/modules/load-management/store/load-management.state';
import { JobFileService } from '@core/services/job-file.service';
import { SetNotificationAction } from '@core/store/notification/notification.actions';
import { AlertDialogType } from '@shared/models';
import { LoadJobFile } from 'app/modules/load-management/store/load-management.actions';

@Component({
  selector: 'hmt-job-plan-order-row',
  templateUrl: './job-plan-order-row.component.html',
  styleUrls: ['./job-plan-order-row.component.scss'],
  standalone: false
})
export class JobPlanOrderRowComponent {
  @Input() order!: ShipmentOrderSpec;

  /** CSS class for priority badge (handles API casing). */
  get priorityBadgeClass(): string {
    const p = (this.order?.priority ?? '').toString().trim().toLowerCase();
    if (p === 'high') {
      return 'priority-badge--high';
    }
    if (p === 'medium') {
      return 'priority-badge--medium';
    }
    return 'priority-badge--low';
  }
  @Input() expanded = false;
  @Input() selected = false;
  @Input() partiallySelected = false;
  @Input() deletable = true;
  @Input() hideCheckbox = false;
  @Output() expandToggle = new EventEmitter<void>();
  @Output() checkboxChange = new EventEmitter<boolean>();
  @Output() deleteOrder = new EventEmitter<void>();

  constructor(
    private dialog: MatDialog,
    private store: Store,
    private jobFileService: JobFileService
  ) {}

  onExpandToggle(event: Event): void {
    event.stopPropagation();
    this.expandToggle.emit();
  }

  onCheckboxChange(event: any): void {
    this.checkboxChange.emit(event.checked);
  }

  onDelete(event: Event): void {
    event.stopPropagation();
    
    const dialogData: ConfirmationDialogData = {
      message: 'Are you sure you want to remove the order?',
      showCheckbox: true,
      checkboxText: 'Remove this order from Order Manager as well',
      imagePath: 'assets/icons/defaultIcon.png'
    };

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '800px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((result: ConfirmationDialogResult) => {
      if (result && result.buttonPressed === 'yes') {
        const shouldDeleteFromOrderManager = result.checkboxChecked;
        const shipmentOrderId = this.order.id || this.order.orderId;
        const jobFile: JobFile = this.store.selectSnapshot(LoadManagementState.jobFile);
        
        if (jobFile?.jobRefId && jobFile?.orgId && shipmentOrderId) {
          this.jobFileService.deleteShipmentOrderSpecFromJobFile(
            jobFile.jobRefId,
            shipmentOrderId,
            shouldDeleteFromOrderManager
          ).subscribe({
            next: () => {
              this.store.dispatch(new SetNotificationAction('Successfully deleted shipment order', AlertDialogType.SUCCESS));
              this.store.dispatch(new LoadJobFile(jobFile.orgId, jobFile.jobRefId));
              this.deleteOrder.emit();
            },
            error: () => {
              this.store.dispatch(new SetNotificationAction('Error deleting shipment order', AlertDialogType.ERROR));
            }
          });
        }
      }
    });
  }
}

